import React from 'react';
import i18next from "./i18n";
const mime = require('mime-types');
export const UserContext = React.createContext();
export const actionTypes = {
    preview: 0,
    sign: 1,
    edit: 2,
    remove: 3,
    download: 4,
    block: 5,
    unblock: 6,
    export: 7,
    add: 8,
    addDir: 9,
    toAcreditation: 10,
    additionalSign: 11,
    save: 12,
    cancel: 13,
    loadSigns: 14,
    notAdd: 15,
    reject: 16,
    annul: 17,
    previewMainDocument: 18,
    reset: 19,
    join: 20,
    changeTaslExecuter: 21,
    change: 22,
    loadP7s: 23,
    batchOperations: 24,
    fill: 25,
    up: 26,
    down: 27
}
export const constants = {
    allowedInfoFileExtensions: ['pdf'],
    acceptInfoIputFileString: "application/pdf",
    placeholderDialogId: "placeholder-modal-dialog"
}
export const allowedStatutoryFileExtensions = ["pdf", "png", "jpg", "jpeg", "bmp", "tif", "tiff", "txt", "zip", "rar", "doc", "docx", "xlsx", "xls"];
export const acceptInputFileString = allowedStatutoryFileExtensions.map((item) => mime.lookup(item)).join(",");
export const allowedPricesFileExtensions = ['xlsx', 'xls'];
export const acceptPricesInputFileString = allowedPricesFileExtensions.map((item) => mime.lookup(item)).join(",");
export const allowedCommentFileExtensions = ["pdf", "png", "jpg", "jpeg", "bmp", "tif", "tiff", "txt", "doc", "docx", "rtf", "odt", "xlsx", "xls"];
export const acceptCommentInputFileString = allowedCommentFileExtensions.map((item) => mime.lookup(item)).join(",");
export const allowedAdditionalFileExtensions = ["pdf", "png", "jpg", "jpeg", "bmp", "tif", "tiff", "txt", "doc", "docx", "rtf", "odt", "xlsx", "xls"];
export const acceptAdditionalInputFileString = allowedAdditionalFileExtensions.map((item) => mime.lookup(item)).join(",");
export const allowedMainFileExtensions = ["pdf"];
export const acceptMainInputFileString = allowedMainFileExtensions.map((item) => mime.lookup(item)).join(",");
export const allowedImageFileExtensions = ["png", "jpg", "jpeg", "bmp", "tif", "tiff"];
export const leftMenuTypes = {
    divider: 'divider',
    link: 'link'
}
export const urls = {
    accessDeniedUrl: '/no-acces',
    loginPageUrl: '/login'
}
export const statusFieldColors = {
    "Default": "rgba(84, 188, 235, 0.2)",
    "Selected": "rgba(244, 123, 32, 0.2)",
    "Не підписано": "#FDE5D3",
    "Активний": "#CDF2DA",
    "Заблокований": "#F2D6D1",
    "Підтвердження пошти": "#FFF5CE",
    "На розгляді COFCO": "rgba(217, 218, 86, 0.6)",
    "Додаткове підписання контрагентом": "rgba(248, 152, 29, 0.6)",
    "В архіві": "rgba(153, 153, 153, 0.2)",
    "Дійсний": "#CDF2DA",
    "На акредитації Сofco": "rgba(217, 218, 86, 0.6)",
    "Підтверджено Cofco": "#CDF2DA",
    "На доопрацюванні контрагентом": "#a4eff5"
}
export const resources = {
    pricesTemplateFileName: 'PricesTemplate.xlsx',
    loadingIcone: '/img/loading.svg',
    logoutIcone: '/img/MenuIcons/logout_v2.svg',
    userInstructionFileName: 'instruction'
}
export const companyTypes = {
    Entity: 'Legal Person',
    Individual: 'FOP'
}
export const companyTypeValues = [
    {
        title: i18next.t("legalEntity"),
        value: companyTypes.Entity
    },
    {
        title: i18next.t("individualEntity"),
        value: companyTypes.Individual
    }
]
export const legalForms = {
    LimitedLiabilityCompany: 'limitedLiabilityCompany',
    JointStockCompany: 'jointStockCompany',
    StateEnterprise: 'stateEnterprise',
    SubsidiaryCompany: 'subsidiaryCompany',
    PrivateEnterprise: 'privateEnterprise',
    AdditionalLiabilityCompany: 'additionalLiabilityCompany',
    AgriculturalProductionCooperative: 'agriculturalProductionCooperative',
    Farm: 'farm',
    AnotherSeparateUnit: 'anotherSeparateUnit'
}
export const formFieldTypes = {
    select: "select",
    int: "int",
    bool: "bool",
    string: "string",
    datetime: "datetime",
    phone: "phone",
    empty: "empty",
    elevatorData: "elevatorData"
}
export const formStringFieldPatterns = {
    phone: "phone",
    email: "email",
    codeIPN: "codeIPN",
    codeEDRPO: "codeEDRPO",
    mFO: "mFO",
    legalPersonIPN: "legalPersonIPN",
    number: "number",
    cash: "cash",
    weight: "weight"
}
export const counterpartyKind = {
    OtherPartners: "Other Partners",
    OwnCompany: "Own Company",
    Mediator1: "Mediator 1",
    Mediator2: "Mediator 2",
    Maker: "Maker"
}
export const docTypes = {
    contract: "8",
    request: "4",
    simplerequest: "10",
    sourcedocument: "7",
    outgoingDocument: "5",
    certificate: "11"
}
export const settingsFormTypes = {
    settingsType: 'settings',
    adminType: 'admin'
}
export const statutoryDocTypes = {
    statutory: 0,
    template: 1
}
export const filterOperatioTypes = {
    And: 0,
    Or: 1
}
export const searchTableTypes = {
    Users: 0,
    Companies: 1,
    Documents: 2,
    Requests: 3,
    PendingDocuments: 4,
    Contracts: 5
}
export const menuTypes = {
    Documents: "docs",
    Requests: "request",
    Pending: "",
    WithoutMenu: "without"
}
export const formModes = {
    all: "all",
    create: "create",
    read: "read",
    edit: "edit",
}
export const attachmentStatuses = {
    Missing: "Missing",
    NotAdded: "Not Added",
    New: "New",
    Signed: "Signed"
}
export const filterDividers = {
    FilterPartsDivider: 'ˍ',
    FilterValuesDivider: '`',
    FilterNameValueDivider: '^'
}
export const alfrescoAssociations = {
    additionalDocuments: "sxcfc:additionalDocuments",
    certificateAdditionalDocuments: "sxcfc:ISCCEUCertificateAdditionalDocuments"
}
export const alfrescoTypes = {
    forwarderContract: "sxcfc:forwarderContract",
    outgoingDocument: "sxcfc:outgoingDocument",
    counterpartyAccreditationCard: "sxcfc:counterpartyAccreditationCard",
    simpleCounterpartyAccreditationCard: "sxcfc:simpleCounterpartyAccreditationCard",
    incomingDocument: "sxcfc:incomingDocument",
    additionalDocument: "sxcfc:additionalDocument",
    certificateAdditionalDocument: "sxcfc:ISCCEUCertificateAdditionalDocument",
    certificate: "sxcfc:ISCCEUCertificate"
}
export const certificateAttachedTypes = {
    ISCCEU_1: "ISCCEU_1",
    ISCCEU_2: "ISCCEU_2",
    ISCCEU_3: "ISCCEU_3",
    ISCCEU_4: "ISCCEU_4",
    ISCCEU_5: "ISCCEU_5",
    ISCCEU_6: "ISCCEU_6",
    ISCCEU_7: "ISCCEU_7",
    ISCCEU_8: "ISCCEU_8",
    ISCCEU_9: "ISCCEU_9"
}
export const docTypeMapping = [
    {
        docType: docTypes.contract,
        alfrescoType: alfrescoTypes.forwarderContract
    },
    {
        docType: docTypes.request,
        alfrescoType: alfrescoTypes.counterpartyAccreditationCard
    },
    {
        docType: docTypes.simplerequest,
        alfrescoType: alfrescoTypes.simpleCounterpartyAccreditationCard
    },
    {
        docType: docTypes.sourcedocument,
        alfrescoType: alfrescoTypes.incomingDocument
    },
    {
        docType: docTypes.outgoingDocument,
        alfrescoType: alfrescoTypes.outgoingDocument
    },
    {
        docType: docTypes.certificate,
        alfrescoType: alfrescoTypes.certificate
    },
]
export const signatureStates = {
    signed: "1"
}
export const paginationSettings = {
    paginationTemplates: [
        {
            label: '5',
            value: 5
        },
        {
            label: '10',
            value: 10
        },
        {
            label: '50',
            value: 50
        },
        {
            label: '100',
            value: 100
        }
    ],
    buttonsCount: 9 // minimum 7
}
export const documentsRegisterRoutes = [
    {
        lable: i18next.t("pendingDocuments"),
        path: "/",
        saveApi: ``,
        type: searchTableTypes.PendingDocuments,
        typeOfMenu: menuTypes.Pending
    },
    {
        lable: i18next.t("documents"),
        path: "/documents/docs/:status?",
        saveApi: `Table/save?searchTableTypes=${searchTableTypes.Documents}`,
        type: searchTableTypes.Documents,
        typeOfMenu: menuTypes.Documents
    },
    {
        lable: i18next.t("accreditationApplications"),
        path: "/documents/request/:status?",
        saveApi: `Table/save?searchTableTypes=${searchTableTypes.Requests}`,
        type: searchTableTypes.Requests,
        typeOfMenu: menuTypes.Requests
    }
]
export const docsForRepresentationTypes = {
    extraction: "Extraction",
    powerOfAttorney: "Power of Attorney",
    statute: "Statute",
    order: "Order",
    protocol: "Protocol"
}
export const docsForRepresentationDictionary = [
    {
        value: docsForRepresentationTypes.extraction,
        label: i18next.t("extraction")
    },
    {
        value: docsForRepresentationTypes.powerOfAttorney,
        label: i18next.t("powerOfAttorney")
    },
    {
        value: docsForRepresentationTypes.statute,
        label: i18next.t("statute")
    },
    {
        value: docsForRepresentationTypes.protocol,
        label: i18next.t("protocol")
    },
    {
        value: docsForRepresentationTypes.order,
        label: i18next.t("order")
    }
]
export const alfrescoRoles = {
    PORTAL_ADMINISTRATOR: "PORTAL_ADMINISTRATOR",
    MODERATOR: "MODERATOR"
}
export const alfrescoUserSates = {
    Active: "active",
    Blocked: "deactivated"
}
export const documentStatuses = {
    All: "All",
    additionalSigningCounterparty: "Additional Signing Counterparty", //Додаткове підписання контрагентом
    project: "Project",
    refinementCounterparty: "Refinement Counterparty", //На доопрацюванні контрагентом
    rejected: "Rejected", //Відхилено COFCO
    archive: "Archived", //В архіві
    preparation: "Preparation", //Підготовка
    signingCounterparty: "Signing Counterparty", //На підписанні контрагентом
    signingCounterpartyMD: "Signing_Counterparty_MD", //На підписанні контрагентом (б/с)
    additionalSigningCounterpartyMD: "Additional_Signing_Counterparty_MD", //Додаткове підписання контрагентом (б/с)
    agreement: "Agreement", //На узгодженні
    rejectedCounterparty: "Rejected Counterparty", //Відхилено контрагентом
    valid: "Valid", //Дійсний
    preparationCounterparty: "Preparation Counterparty", //На підготовці контрагентом
    familiarizationCounterparty: "Familiarization Counterparty", //На ознайомленні контрагентом
    processingCounterparty: "Processing_Counterparty", //На обробці контрагентом
    performingCounterparty: "Performing_Counterparty" //На виконанні контрагентом
}
export const documentBpActions = {
    approve: "Approve",
    sign: "Sign",
    send: "send",
    annul: "Annul",
    reject: "Reject",
    additionalSigning: "AdditionalSigning",
    toAdditionalSigning: "toAdditionalSigning",
    refinement: "Refinement",
    addConnection: "addConnection"
}
export const initiatorSystem = {
    COFCO: "COFCO",
    PORTAL: "PORTAL"
}
export const loginFaildeStatus = {
    userBlocked: "userIsNotActive",
    userNotExist: "userDoesNotExist"
}
export const documentPropNames = {
    id: "sys:node-uuid",
    title: "cm:title",
    state: "sx:state",
    type: "sx:documentType"
}
export const maxFileSize = 47190000; //byte
export const maxRequestAttachmentSize = 5242880; //byte
export const commentMaxFileSize = 10485760; //byte